<template>
  <div class="fof">
    <img src="../assets/img/404.png" alt="" />
    <p>会话失效，请关闭 app 重新打开</p>
  </div>
</template>
<script>
export default {
  name: "404",
  data() {
    return {};
  },
};
</script>
<style lang="less" scoped>
.fof {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100vh;
  box-sizing: border-box;
  flex-direction: column;

  p {
    margin-top: 10px;
  }

  span {
    color: @theme_color;
    cursor: pointer;
  }
}
</style>